import { TariffCodeSuggestion } from '~/lib/api/smartsend/types';
import { TariffSystemLength } from '~/lib/types/tariff-systems';

export function GetTariffCodeFromSuggestion(system: string, suggestion: TariffCodeSuggestion) {
  const sanitisedSystem = system?.toUpperCase();
  const code = suggestion[sanitisedSystem] || suggestion.HS;
  if (!code) {
    return '';
  }
  return SanitiseTariffCode(sanitisedSystem, code);
}

export function SanitiseTariffCode(system: string, code: string) {
  const sanitisedSystem = system?.toUpperCase();
  return `${code}0000`.substring(0, TariffSystemLength[sanitisedSystem] || TariffSystemLength.HS);
}

export function IsTariffCodeTooShort(system: string, code: string) {
  const sanitisedSystem = system?.toUpperCase();
  const tariffSystemLength = TariffSystemLength[sanitisedSystem] || TariffSystemLength.HS;
  return code.length < tariffSystemLength;
}

export function TrimTariffCode(system: string, code: string) {
  if (!code || !system) {
    return code;
  }

  const sanitisedSystem = system?.toUpperCase();
  const maxLength = TariffSystemLength[sanitisedSystem] || TariffSystemLength.HS;
  return code.substring(0, maxLength);
}
